import { useTranslation } from 'next-i18next';
import React, { useEffect, useState } from 'react';
import { Booth } from '../../../../../interfaces/interfaces';
import { InfoBoothComponentInterface, UiComponentElementInterface } from '../../../../../interfaces/pagebuilder';
import { useSelector } from '../../../../../reduxToolkit/typedRedux';
import EmptyComponent from '../../../pageBuilder/EmptyComponent';
import { TitleAndDescription } from '../../../pageBuilder/TitleAndDescription';
import BigBooth from '../oneonone/BigBooth/index';

const InfoBoothUiComponent = ({ uiComponent }: UiComponentElementInterface<InfoBoothComponentInterface>) => {
  const booths = useSelector((state) => state.common.booths);
  const { t } = useTranslation('pagebuilder');

  const [booth, setBooth] = useState<Booth | undefined>();

  useEffect(() => {
    const b: Booth | undefined = booths?.find((booth) => booth._id === uiComponent?.boothId);
    setBooth(b);
  }, [uiComponent?.boothId, booths]);

  return (
    <>
      <TitleAndDescription component={uiComponent!} />
      <div
        className={`w-full overflow-hidden`}
        style={{
          color: uiComponent?.styling?.textColor || '#000',
        }}>
        {booth ? (
          <div className="bg-white text-black">
            <BigBooth booth={booth} />
          </div>
        ) : (
          <EmptyComponent componentName={t('pagebuilder:info-booth')} />
        )}
      </div>
    </>
  );
};

export default InfoBoothUiComponent;
